import type { SupplyChannel } from '../../api/types'

// Vocabolario comune alle due schermate delle proposte. La lettura del minimo d'ordine è il
// gesto centrale di questa parte dell'applicazione e deve avere sempre la stessa forma.
//
// L'avanzamento verso il minimo arriva dal server già in percentuale: il valore dell'ordine non
// esce dall'API, quindi qui non c'è nulla da calcolare e nulla da convertire in denaro.

/** L'avanzamento ha raggiunto la soglia, è sotto la soglia, oppure la soglia non è impostata. */
export type ThresholdState = 'reached' | 'missing' | 'unknown'

/**
 * Soglia non impostata e soglia raggiunta sono due cose diverse e vanno tenute separate.
 * Quando il fornitore non ha un minimo d'ordine il server risponde 100: la proposta è completa.
 * Quando invece la soglia non è configurata la percentuale è assente, ed è un dato che non
 * abbiamo: dirlo è meglio che mostrare una barra vuota che sembra un ordine da completare.
 */
export function thresholdState(percent?: number | null): ThresholdState {
  if (percent === undefined || percent === null) return 'unknown'
  return percent >= 100 ? 'reached' : 'missing'
}

/** Percentuale intera: il server la manda già arrotondata, qui si aggiunge solo il segno. */
export function formatPercent(value: number) {
  return `${value.toLocaleString('it-IT', { maximumFractionDigits: 0 })}%`
}

/**
 * I colli arrivano con divisione non intera: mostriamo i decimali solo quando ci sono.
 * Un numero assente diventa un trattino invece di far cadere la pagina: è un formattatore di
 * visualizzazione, e una riga senza colli non è un buon motivo per non mostrare la proposta.
 */
export function formatPacks(value?: number | null) {
  if (value === undefined || value === null) return '—'
  return value.toLocaleString('it-IT', { maximumFractionDigits: 2 })
}

export function channelLabel(channel: SupplyChannel, sourceCedi?: string) {
  if (channel === 'Cedi') return sourceCedi ? `CEDI ${sourceCedi}` : 'CEDI'
  return 'Fornitore diretto'
}

export function channelHint(channel: SupplyChannel) {
  return channel === 'Cedi' ?
      'Rifornimento dal centro di distribuzione: la soglia è in colli.'
    : 'Ordine diretto al fornitore: la soglia è il minimo d’ordine concordato.'
}
